<ion-radio labelPlacement="start" justify="space-between" [value]="value" [disabled]="disabled">
    <ng-content></ng-content>
</ion-radio>
